export const endpointStatus = {
    success: "success",
};